import { GenericClassTranslate } from './genericClass';

export class AccessoryEquipmentType extends GenericClassTranslate{

}

export enum AccessoryEquipmentTypeEnum  {
    OTHERS = 5
}